import { PopupBannerCommonProps } from '~containers/PopupResolver/PopupBanner/PopupBanner.types';
import { PopupCardCommonProps } from '~containers/PopupResolver/PopupCard/PopupCard.types';
import { PopupPictureCommonProps } from '~containers/PopupResolver/PopupPicture/PopupPicture.types';

export const PopupTypes = {
  card: 'card',
  banner: 'banner',
  picture: 'picture',
} as const;

export type PopupTargetActionEvents = {
  ymEvent?: string;
  tmrEvent?: string;
};

export type PopupCallbacks = {
  onTargetAction?: (
    actionValue: string,
    shouldClose?: boolean,
    events?: PopupTargetActionEvents,
  ) => void;
  onClose?: () => void;
};

export type PopupResolverProps = PopupCallbacks &
  (PopupCardCommonProps | PopupBannerCommonProps | PopupPictureCommonProps);
